import { Typography } from "@mui/material";

function SectionHeading({ children }) {
  return (
    <Typography
      variant="body2"
      sx={{
        fontSize: "62px",
        fontWeight: "700",
        lineHeight: "70px",
        color: "#0E0B33",
        textAlign: "center",
      }}
    >
      {children}
    </Typography>
  );
}

export default SectionHeading;
